import React, { Component } from 'react';
class Footer extends Component {
    render() {
        return (          
            <div className="section slide-personal-Intro-sixth slide-dark" id="contact">                
                <footer id="footer" className="footer footer-s1 footer-s1-home1">
                    <div id="footer-widget" className="footer-widget-s1 footer-widget-line bg-s1 position-relative">
                    <div className="container">
                        <div className="row d-lg-flex align-items-center text-center">
                        <div className="col-lg-12">
                            <h3 className="widget-title larger lt-sp06">Stay Connected</h3>
                        </div>
                        <div className="col-lg-12">
                            <div className="widget-info">
                            <p className="address">Odisha, India</p>
                            <p className="mail gmailer">girisuman289@gmail.com</p>
                            <a href="https://wa.me/9937903731?text=Hello%20Suman,%20I'm%20interested%20in%20your%20projects%20can%20we%20have%20a%20talk%20?" target="_blank" rel="noreferrer" className="phone"> <img src="https://img.icons8.com/material-outlined/30/000000/whatsapp--v1.png" alt="img"/>  +91 9937903731</a>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="site-list site-list-pdl text-center">
                            <a href="https://github.com/SumanJK" className="bg-s2"  target="_blank" rel="noreferrer"> <i className="fa fa-behance" aria-hidden="true" /></a>
                            <a href="https://www.linkedin.com/in/suman-giri-/" className="bg-s3" target="_blank" rel="noreferrer"> <i class="fa fa-linkedin" aria-hidden="true"></i></a>
                            <a href="https://medium.com/@girisuman289" target="_blank" className="bg-s1" rel="noreferrer"> <i class="fa fa-medium" aria-hidden="true"></i></a>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div id="bottom" className="bottom-s1">
                    <div className="container d-lg-flex justify-content-between">
                        <div className="copyright lt-sp02">
                        © Created with React
                        </div>
                        <div className="socials-list color-s1">
                        <a href="https://github.com/SumanJK" target="_blank" rel="noreferrer"> <i className="fa fa-facebook" aria-hidden="true" /></a>
                        <a href="https://www.linkedin.com/in/suman-giri-/" target="_blank" rel="noreferrer"> <i className="fa fa-instagram" aria-hidden="true" /> </a>
                        <a href="https://twitter.com/SumaN2point0" target="_blank" rel="noreferrer"> <i className="fa fa-twitter" aria-hidden="true" /></a>
                        </div>
                    </div>
                    </div>
                </footer>             
            </div>
        );
    }
}

export default Footer;
